import React, {useContext} from "react";
import en from "../../assets/images/en.svg";
import he from "../../assets/images/he.svg";
import { useTranslation } from "react-i18next";
import {AuthUserContext } from "../../context"
function Navbars() {
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { setTaostValue } = useContext(AuthUserContext);

  return (
    <div className="container">
      <div className="row ">
        <div className="col-md-12 d-flex gap-3  pt-3 justify-center pb-4">
          <div
            className="d-flex gap-2 cursor-pointer hover:bg-[#cfcfd792] p-2"
            onClick={() => {
              changeLanguage("en");
              setTaostValue("en")
            }}
          >
            <img src={en} alt="en" />
            English
          </div>
          <div
            className="d-flex gap-2 cursor-pointer p-2 hover:bg-[#cfcfd792]"
            onClick={() => {
              changeLanguage("he");
              setTaostValue("he")
            }}
          >
            <img src={he} alt="en" />
            עברית (Hebrew)
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbars;
